import axios from 'axios'

const SSOService = {
  async post (payload = {}) {
    return axios.post('auth/sso/oauth2', payload)
  }
}

export default SSOService
